import { Breadcrumb } from 'components/breadcrumb'
import { PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { Switch, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import GarantiaAcessoAgendarConsultaModalForm from './agendamento/GarantiaAcessoAgendarConsultaModalForm'
import GarantiaAcessoEditarCidadaoModalForm from './edicao/GarantiaAcessoEditarCidadaoModalForm'
import GarantiaAcessoView from './GarantiaAcessoView'
import GarantiaAcessoRemoverCidadaoModalForm from './remocao/GarantiaAcessoRemoverCidadaoModalForm'

export function DemandaReprimidaRootView() {
  const match = useRouteMatch()
  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()

  return (
    <>
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && <Breadcrumb title='Nesta unidade de saúde' />}
      <GarantiaAcessoView />
      <Switch>
        <PrivateRoute
          path={`${match.url}/remover-cidadao/:garantiaAcessoId/`}
          component={GarantiaAcessoRemoverCidadaoModalForm}
          permission={Permissions.visualizarListaDeAtendimento}
        />
        <PrivateRoute
          path={`${match.url}/agendar-consulta/:garantiaAcessoId/`}
          component={GarantiaAcessoAgendarConsultaModalForm}
          permission={Permissions.visualizarAgenda.agendarEEditar}
        />
        <PrivateRoute
          path={`${match.url}/editar-cidadao/:garantiaAcessoId/`}
          component={GarantiaAcessoEditarCidadaoModalForm}
          permission={Permissions.visualizarListaDeAtendimento}
        />
      </Switch>
    </>
  )
}
